import React from "react";
import { CreateNft } from "../components/CreateNft/CreateNft";

export const CreateNftPage = () => {
  return <CreateNft />;
};
